export default __webpack_public_path__ + "static/media/clock-tick_100bpm_C.562ab6d7.wav";